import React from "react";
import {Grid} from "@mui/material";
import {BaseInput} from "../../../../designSystem/components/BaseInput";

export const PulseForm = ({
  measurement,
  onChangeMeasurement,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <BaseInput
        type="number"
        onChange={e => onChangeMeasurement({...measurement, pulse: e.target.value})}
        value={measurement.pulse}
        placeholder="心跳(BPM)"
      />
    </Grid>
  </Grid>
)